<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="资源管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item class="topOne">
									<el-input v-model="searchForm.search_text" placeholder="请填写请输入达人昵称/达人账号/主页链接" clearable
										style="width: 100%;"></el-input>
								</el-form-item>
								<el-form-item label="平台">
									<el-select v-model="searchForm.pid" filterable placeholder="请选择平台" clearable @change="doSearch">
										<el-option v-for="item in options.platform_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="供应商">
									<el-select v-model="searchForm.sid" filterable placeholder="请选择供应商" clearable>
										<el-option v-for="item in options.supplier_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="标签">
									<el-select v-model="searchForm.tag" filterable placeholder="请选择标签" clearable>
										<el-option v-for="item in options.tag_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="价格">
									<el-select v-model="searchForm.price" filterable placeholder="请选择价格" clearable>
										<el-option v-for="item in options.parice_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="粉丝数">
									<el-select v-model="searchForm.fans_num" filterable placeholder="请选择粉丝数" clearable>
										<el-option v-for="item in options.fans_num_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="地区">
									<el-select v-model="searchForm.area" filterable placeholder="请选择地区" clearable>
										<el-option v-for="item in options.area_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发布形式">
									<el-select v-model="searchForm.type" filterable placeholder="请选择发布形式" clearable>
										<el-option v-for="item in options.klprice_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con k-common-con-resource">
						<div class="k-table-wrapper">
							<div class="resourceHandleTop" style="height: 38px;">
								<div class="projectName">
									项目名称:<span>{{ queryParams.project_name }}</span>
								</div>
								<div class="btn">
									<div class="badge-box">
										<template
											v-if="!searchForm.pid || searchForm.pid == 1 || searchForm.pid == 4 || searchForm.pid == 5 || searchForm.pid == 6 || searchForm.pid == 7 || searchForm.pid == 9 || searchForm.pid == 10">
											<div class="s1 s4"></div>
											<div class="s2">平台展示价</div>
										</template>
										<template
											v-if="!searchForm.pid || searchForm.pid == 1 || searchForm.pid == 4 || searchForm.pid == 6">
											<div class="s3 s4"></div>
											<div class="s2">非平台报价</div>
										</template>
										<template
											v-if="!searchForm.pid || searchForm.pid == 3 || searchForm.pid == 8 || searchForm.pid == 2">
											<div class="s3 s5"></div>
											<div class="s2">资源报价</div>
										</template>
									</div>
									<el-popover v-if="cartList.length > 0" placement="bottom" width="400" trigger="click">
										<div class="cartBox">
											<div class="maxPop">
												<ul class="pop_ul">
													<li v-for="(item, index) in cartList" :key="index" :class="{ hover: isHovering[index] }"
														@mouseover="toggleHover(index, true)" @mouseleave="toggleHover(index, false)">
														<img :src="item.avatar_url" v-if="item.avatar_url" class="avatar_url" alt="">
														<img src="../../assets/images/admin.png" class="avatar_url" v-else>
														<div class="right">
															<p>
																<img :src="item.platform_logo" class="icon_s" alt="">
																{{ item.name }}
															</p>
															<p>粉丝数：{{ item.fans_num }}w</p>
														</div>
														<img src="../../assets/images/del.png" class="del" alt="" @click="delCart(index)">
													</li>
												</ul>
											</div>
											<el-button type="primary" size="mini" class="pop_ul_btn"
												@click="addRelationresource">添加至项目</el-button>
										</div>
										<div class="cart" slot="reference"><img src="../../assets/images/cart.png" alt=""> 已选资源 <span
												data-v-7a4e584c="" class="num">{{ cartNum }}</span></div>
									</el-popover>
									<div v-else class="cart" slot="reference"><img src="../../assets/images/cart.png" alt=""> 已选资源 <span
											data-v-7a4e584c="" class="num">{{ cartNum }}</span></div>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id" ref="table" v-loading="loading"
									highlight-current-row @sort-change="sortChange" :height="tableHeight">
									<el-table-column prop="pid" label="账号" align="center" min-width="260">
										<template slot-scope="scope">
											<div class="cell-account" style="cursor: auto;">
												<div class="icon">
													<img class="icon-big" :src="scope.row.avatar_url" v-if="scope.row.avatar_url">
													<img class="icon-big" src="../../assets/images/admin.png" v-else>
												</div>
												<div class="content">
													<div class="title">
														<img class="icons" :src="scope.row.platform_logo">
														<span>{{ scope.row.name }}</span>
													</div>
													<div class="area">
														<img class="icons" src="../../assets/images/icon6.png">
														<span>{{ scope.row.area ? scope.row.area : '未知' }}</span>
													</div>
													<div class="tag-box">
														<div class="tag" v-for="(item, index) in scope.row.tags" v-if="scope.row.tags.length > 0">
															{{ item }}</div>
														<div v-if="scope.row.tags.length == 0">暂无标签</div>
													</div>
												</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="fans_num" label="粉丝数(W)" align="center" sortable min-width="120">
									</el-table-column>
									<el-table-column prop="pid" label="历史合作次数" align="center" sortable min-width="150">
									</el-table-column>
									<el-table-column prop="pid" label="供应商" align="center" min-width="240">
										<template slot-scope="scope">
											<template v-if="scope.row.supplier_list.length > 0">
												<span class="text-font" v-for="item in scope.row.supplier_list"
													v-if="item.is_default == 1">{{ item.supplier_name }}</span>
												<div class="yxq">有效期：{{ scope.row.price_validity }}</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="pid" label="发布方式" align="center" min-width="180">
										<template slot-scope="scope">
											<template v-if="scope.row.price_names.length > 0">
												<div :class="scope.row.price_names.length > 2 ? 'price-box price-box-pad' : 'price-box'">
													<div class="price-box-inner">
														<div v-for="(item, index) in scope.row.price_names" v-if="index < 2">
															<div class="price-cell">
																<div class="p1">{{ item }}</div>
															</div>
														</div>
														<el-popover v-if="scope.row.price_names.length > 2" placement="right" width="370"
															trigger="hover">
															<div class="ressupplier">
																<div class="_row" v-for="(item, index) in scope.row.price_names" :key="index">
																	<div class="str">{{ item }}</div>
																	<div class="dashed"></div>
																	<div class="platform_price"
																		v-if="scope.row.price_list[index].price1 && scope.row.price_list[index].price1.length > 1">
																		<span>{{ scope.row.price_list[index].price1[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price1[1] }}</span>
																	</div>
																	<div class="platform_price"
																		v-if="scope.row.price_list[index].price1 && scope.row.price_list[index].price1.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price1[0] }}</span>
																	</div>
																	<div class="price"
																		v-if="scope.row.price_list[index].price2 && scope.row.price_list[index].price2.length > 1">
																		<span>{{ scope.row.price_list[index].price2[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price2[1] }}</span>
																	</div>
																	<div class="price"
																		v-if="scope.row.price_list[index].price2 && scope.row.price_list[index].price2.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price2[0] }}</span>
																	</div>
																	<div class="price2"
																		v-if="scope.row.price_list[index].price3 && scope.row.price_list[index].price3.length > 1">
																		<span>{{ scope.row.price_list[index].price3[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price3[1] }}</span>
																	</div>
																	<div class="price2"
																		v-if="scope.row.price_list[index].price3 && scope.row.price_list[index].price3.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price3[0] }}</span>
																	</div>
																</div>
															</div>
															<div class="seeMore hoverbtn" slot="reference"> 更多 ></div>
														</el-popover>
													</div>
												</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="pid" label="价格" align="center" width="400">
										<template slot-scope="scope">
											<template v-if="scope.row.price_list.length > 0">
												<div
													:class="scope.row.price_list && scope.row.price_list.length > 2 ? 'price-box price-box-pad' : 'price-box'">
													<div class="price-box-inner">
														<div v-for="(item, index) in scope.row.price_list" :key="index" v-if="index < 2">
															<div class="price-cell" v-if="item.price3">
																<div class="p4" v-if="item.price3.length > 1">
																	<span>{{ item.price3[0] }}</span>
																	<span><i>折</i>{{ item.price3[1] }}</span>
																</div>
																<div class="p4" v-else>
																	<span></span>
																	<span>{{ item.price3[0] }}</span>
																</div>
															</div>
															<div class="price-cell" v-if="item.price1 && item.price2">
																<div class="p2" v-if="item.price1.length > 1">
																	<span>{{ item.price1[0] }}</span>
																	<span><i>折</i>{{ item.price1[1] }}</span>
																</div>
																<div class="p2" v-else>
																	<span></span>
																	<span>{{ item.price1[0] }}</span>
																</div>
																<div class="p3" v-if="item.price2.length > 1">
																	<span>{{ item.price2[0] }}</span>
																	<span><i>折</i>{{ item.price2[1] }}</span>
																</div>
																<div class="p3" v-else>
																	<span></span>
																	<span>{{ item.price2[0] }}</span>
																</div>
															</div>
															<div class="price-cell" v-if="item.price1 && !item.price2">
																<div class="p5" v-if="item.price1.length > 1">
																	<span>{{ item.price1[0] }}</span>
																	<span><i>折</i>{{ item.price1[1] }}</span>
																</div>
																<div class="p5" v-else>
																	<span></span>
																	<span>{{ item.price1[0] }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<el-table-column fixed="right" align="center" width="60">
										<template slot-scope="scope">
											<img src="../../assets/images/cart2.png" class="add" alt="" @click="addCart(scope.row)">
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--修改默认供应商-->
		<el-dialog title="供应商" :visible.sync="editSupplierFormVisiable" v-loading="loading" width="40%">
			<el-form :model="editSupplierForm" ref="editSupplierForm" :size="size" label-width="110px">
				<div class="editSupplierBox">
					<div class="options">
						<el-radio-group v-model="editSupplierForm.sid">
							<el-radio :label="item.sid" v-for="(item, index) in options.supplier_options"
								:key="index">{{ item.supplier_name }}</el-radio>
						</el-radio-group>
					</div>
					<div class="info">
						<div class="title" v-for="(item, index) in options.supplier_options" :key="index">{{ item.isDefault }}</div>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editSupplier" :size='size'>提交</el-button>
				<el-button :size='size' @click="editSupplierFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			addFormVisiable: false,
			editFormVisiable: false,
			checkSkVisiable: false,
			editSupplierFormVisiable: false,
			activeName: 'first',
			activeNameCheck: 'first',
			size: 'mini',
			resource_active: 0,
			resource_title: '选择平台',
			handle: false,//审核中不显示操作栏
			loading: false,
			options: {
				platform_options: [],//平台下拉
				tags_options: [],//标签列表
				platform_list_options: [],//平台
				supplier_list_options: [],//供应商
				tag_list_options: [],//标签
				parice_list_options: [],//价格
				fans_num_list_options: [],//粉丝数
				area_list_options: [],//地区
				klprice_list_options: [],//发布形式
				supplier_options: [{
					sid: 1
				}, { sid: 2 }]//关联供应商列表
			},
			searchForm: {
				search_text: '',
				pid: '',
				sid: '',
				tag: '',
				price: '',
				area: '',
				fans_num: '',
				type: '',
				status: 1
			},
			resetSearch: {
				search_text: '',
				pid: '',
				sid: '',
				tag: '',
				price: '',
				area: '',
				fans_num: '',
				type: '',
				status: 1
			},
			editSupplierForm: {
				id: '',
				sid: ''
			},
			rules: {
				editSupplierForm: {
					'sid': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			uploadForm: {
				file_list: [],//附件
				file_files: []
			},
			formType: 'add',
			cartNum: 0,//购物车数量
			cartList: [],//购物车列表
			isHovering: [],
			queryParams: ''//跳转页面携带参数
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		this.queryParams = this.$route.query;
		this.handleSearch(this.searchForm);
		this.getChecklist()//获取检索下拉
	},
	methods: {
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			param['project'] = 1
			this.$api.get('/admin/resources/resources/resourcelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					if (param.status == 2) {
						this.handle = true
					} else {
						this.handle = false
					}
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//获取平台下拉
		getPlatformdwna () {
			this.$api.get('/admin/resources/resources/platformdwn').then(res => {
				if (res.code === 0) {
					this.options.platform_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//选择平台
		changePlatform () {
			let pid = this.addForm.platform.pid
			let targetId = this.addForm.platform.pid;
			let foundPlatform = this.options.platform_options.find(option => option.id === targetId);
			if (foundPlatform) {
				this.resource_title = foundPlatform.platform_name;
				this.getFiled(this.addForm.platform.pid)
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
		},
		//获取标签
		getTags () {
			this.$api.get('/admin/resources/resources/getTags').then(res => {
				if (res.code === 0) {
					this.options.tags_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取检索下拉项
		getChecklist () {
			this.$api.get('/admin/resources/resources/checklist').then(res => {
				if (res.code === 0) {
					this.options.area_list_options = res.data.area_list;
					this.options.fans_num_list_options = res.data.fans_num_list;
					this.options.platform_list_options = res.data.platform_list;
					this.options.supplier_list_options = res.data.supplier_list;
					this.options.tag_list_options = res.data.tag_list;
					this.options.parice_list_options = res.data.parice_list;
					this.options.klprice_list_options = res.data.klprice_list;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取所有字段
		getFiled (param) {
			this.$api.get('/admin/resources/resources/getfiled', { pid: param }).then(res => {
				if (res.code === 0) {
					this.addForm.data = res.data.data
					this.addForm.info = res.data.info
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取平台数据
		getPlatformData (item) {
			this.$api.post(item.action, { pid: this.addForm.platform.pid, link: item.value }).then(res => {
				if (res.code === 0) {
					let actionData = res.data
					for (let i = 0; i < this.addForm.data.length; i++) {
						if (actionData.hasOwnProperty(this.addForm.data[i].fieldName)) {
							this.addForm.data[i].value = actionData[this.addForm.data[i].fieldName];
						}
					}
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//打开详情页
		detail () {
			this.$router.push({
				name: 'ResourceDetail',
				query: { id: row.id, set_id: 7, type: 'detail' }
			});
		},
		//打开修改关联供应商弹窗
		editSupplierOpen (row) {
			this.options.supplier_options = row.supplier_list
			const defaultSupplierSid = this.options.supplier_options.find(
				(supplier) => supplier.isDefault === "默认供应商"
			).sid;
			this.editSupplierForm.sid = defaultSupplierSid
			this.editSupplierForm.id = row.id
			this.editSupplierFormVisiable = true
		},
		//修改关联供应商
		editSupplier () {
			this.loading = true
			this.$api.post('/admin/resources/resources/editrsd', this.editSupplierForm).then(res => {
				if (res.code === 0) {
					// 重新加载表格
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (this.editSupplierForm.id == item.id) {
							item.supplier_list.forEach((itemc, indexc) => {
								if (itemc.sid == this.editSupplierForm.sid) {
									this.$set(this.tableData.data[index].supplier_list[indexc], 'isDefault', '默认供应商');
								} else {
									this.$set(this.tableData.data[index].supplier_list[indexc], 'isDefault', '非默认供应商');
								}
							})
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '修改成功！',
						type: 'success'
					});
					this.editSupplierFormVisiable = false;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//添加购物车
		addCart (row) {
			if (this.cartList.some(item => item.id === row.id)) {
				this.$confirm('此资源已添加购物车，确定要再次添加吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then((action) => {
					this.cartNum++
					this.cartList.push(row)
					this.$message({
						showClose: true,
						message: '添加成功！',
						type: 'success'
					});
				})
			} else {
				this.cartNum++
				this.cartList.push(row)
				this.$message({
					showClose: true,
					message: '添加成功！',
					type: 'success'
				});
			}
		},
		//购物车鼠标经过
		toggleHover (index, isHovering) {
			// 更新对应索引位置的isHovering数组值
			this.$set(this.isHovering, index, isHovering);
		},
		//从购物车中移除
		delCart (index) {
			this.cartList.splice(index, 1)
			if (this.cartNum != 0) {
				this.cartNum--
			}
		},
		//添加至项目
		addRelationresource () {
			const resource_ids = this.cartList.map(item => item.id);
			this.$confirm('购物车中的' + resource_ids.length + '条资源添加到项目中，确认该操作吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((action) => {
				this.$api.post('/admin/customers/customer/relationresource', { project_code: this.queryParams.project_code, resource_ids: resource_ids }).then(res => {
					if (res.code === 0) {
						this.$message({
							showClose: true,
							message: '添加成功！',
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({
								name: 'Project',
								query: { project_code: this.queryParams.project_code }
							});
						}, 2000);
					} else {
						this.$message.error(res.msg);
					}
				})
			})
				.catch(() => {
					this.$message.error('已取消添加');
				});
		}
	}
}

</script>
<style lang="scss" scoped>
.resourceCon {
	.addBox {
		margin-top: 60px;
	}

	.fyRadio {
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.fyRadioTitle {
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}

	.el-radio {
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}

.resourceHandleTop {
	position: relative;
	padding-bottom: 20px;
	background-color: #fff;

	.btn {
		position: absolute;
		right: 20px;
		top: 0;
		height: 48px;
		display: flex;
		align-items: center;
	}
}

.add {
	width: 20px;
	height: auto;
	cursor: pointer;
	display: flex;
}

.cartBox {
	.maxPop {
		max-height: 460px;
		overflow: auto;

		.pop_ul {
			display: block;
			padding-bottom: 100px;
			margin-top: 30px;
			display: flex;
			align-items: center;
			color: #666;
			font-size: 14px;
			flex-wrap: wrap;

			li {
				width: 100%;
				position: relative;
				display: flex;
				height: 90px;
				align-items: center;
				border-bottom: 1px solid #f7f7f7;
				margin-right: 0;
				padding-left: 24px;
				box-sizing: border-box;

				img.avatar_url {
					width: 40px;
					height: 40px;
					border-radius: 40px;
					margin-right: 16px;
				}

				ul li:nth-child(1) img {
					width: 16px;
					height: 16px;
				}

				.del {
					display: none;
					position: absolute;
					right: 12px;
					top: 35px;
					width: 18px;
					height: 18px;
				}

				&.hover {
					background: #f4f6fb;

					.del {
						display: block;
						cursor: pointer;
					}
				}

				.right p {
					display: flex;
					align-items: center;
				}

				.right p:nth-of-type(1) {
					color: #303030;
					font-size: 16px;
					font-weight: 700;
				}

				.right p:nth-of-type(2) {
					color: #666;
					font-size: 12px;
				}

				.icon_s {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}
	}

	.pop_ul_btn {
		position: absolute;
		height: 36px;
		width: 332px;
		left: 50%;
		transform: translate(-50%);
		bottom: 10px !important;
	}
}

.projectName {
	font-weight: bold;
	padding-left: 20px;
	line-height: 48px;
	font-size: 14px;

	span {
		font-weight: normal;
	}
}
</style>